export default __webpack_public_path__ + "static/media/aka-07121802-17919@3x.b06f1259.png";